$(document).ready(function(){

  // Add QueryString parsing function to jQuery
  (function($) {
    $.QueryString = (function(a) {
      if (a == "") return {};
      var b = {};
      for (var i = 0; i < a.length; ++i)
      {
        var p=a[i].split('=');
        if (p.length != 2) continue;
        b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
      }
      return b;
    })(window.location.search.substr(1).split('&'))
  })(jQuery);
  
  // Check if refferal_code is included in the URL and add as cart attribute
  var referral_code = $.QueryString['ref'];
  if(referral_code) {
    result = $.post('/cart/update.js', "attributes[Referral Code]=" + referral_code);
  }

});

